<po-page-default class="po-pb-2">
  <app-toaster></app-toaster>

  <po-modal 
    #modalConferenceDescription
    p-title="Descrição da Conferência"
    [p-primary-action]="modalPrimaryAction"
    [p-secondary-action]="modalSecondaryAction">
    <div class="po-row">
      <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12">
        <po-input
          name="conferenceDescription"
          p-label="Descrição"
          [(ngModel)]="conferenceDescription"
          p-placeholder="Digite a descrição da conferência"
          [p-maxlength]="100"
          p-required
          p-clean>
        </po-input>
      </div>
    </div>
  </po-modal>

  <div class="row po-font-text-small po-mb-3">
    <app-step-breadcrumb [breadcrumbs]="breadcrumbs" [activeIndex]="orderCountStep"
            (breadcrumbClick)="navigateBreadcrumb($event)"></app-step-breadcrumb>
  </div>
  <div class="po-row po-mb-1">
      <div class="po-xl-10 po-lg-10 po-md-9 po-sm-12">
          <p class="po-font-title">Conferência de Embarque</p>
      </div>
  </div>

  <div class="po-row">
    <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12">
      <div class="po-row">
        <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12">
          <p class="po-font-text-large-bold"> 
            <span class="po-info-label">Nota Fiscal:</span> 
            <span>{{ invoiceCode }}</span>
          </p>
        </div>
      </div>

      <div class="po-row" *ngIf="isScannerVisible">
        <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12">
          <app-scanner (scannedData)="onScannedData($event)" p-label="Ler código do produto">
          </app-scanner>
        </div>
      </div>

      <div class="po-row">
        <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12">
          <div class="scanner-info">
            <po-container>
              <div class="po-row">
                <div class="po-xl-4 po-lg-4 po-md-12 po-sm-12">
                  <div class="info-box">
                    <span class="info-label">Itens esperados</span>
                    <span class="info-value">{{ expectedItems }}</span>
                  </div>
                </div>
                <div class="po-xl-4 po-lg-4 po-md-12 po-sm-12">
                  <div class="info-box">
                    <span class="info-label">Conferidos</span>
                    <span class="info-value">{{ conferredItems }}</span>
                  </div>
                </div>
                <div class="po-xl-4 po-lg-4 po-md-12 po-sm-12">
                  <div class="info-box">
                    <span class="info-label">Qtd. Faltante</span>
                    <span class="info-value">{{ missingItems }}</span>
                  </div>
                </div>
              </div>
              <div class="po-row">
                <span class="info-label">Progresso </span>
                <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12">
                  <div class="progress-container">
                    <div class="progress-bar" [style.width.%]="progress">
                      <span class="progress-text">{{progress}}%</span>
                    </div>
                  </div>
                </div>
              </div>
            </po-container>
          </div>
        </div>
      </div>

      <div class="po-row">
        <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12">
          <po-container>
            <div class="items-list">
              <div class="po-row">
                <div class="po-xl-4 po-lg-4 po-md-4 po-sm-12 po-mb-sm-1">
                  <po-button class="po-sm-12" p-label="Aguardando Conferência" 
                    [p-kind]="activeStatusFilter === 'waiting' ? 'primary' : 'none'"
                    (p-click)="setStatusFilter('waiting')">
                  </po-button>
                </div>
                <div class="po-xl-4 po-lg-4 po-md-4 po-sm-12 po-mb-sm-1">
                  <po-button class="po-sm-12" p-label="Em Conferência" 
                    [p-kind]="activeStatusFilter === 'inProgress' ? 'primary' : 'none'"
                    (p-click)="setStatusFilter('inProgress')">
                  </po-button>
                </div>
                <div class="po-xl-4 po-lg-4 po-md-4 po-sm-12">
                  <po-button class="po-sm-12" p-label="Conferido" 
                    [p-kind]="activeStatusFilter === 'completed' ? 'primary' : 'none'"
                    (p-click)="setStatusFilter('completed')">
                  </po-button>
                </div>
              </div>

              <div class="items-group">
                <div *ngIf="currentItems.length === 0" class="po-mb-2 po-text-center">
                    <div class="empty-state">
                      Sem itens listados
                    </div>
                </div>
                <div class="item-card po-mb-2" *ngFor="let item of currentItems">
                  <div class="item-header">
                    <div class="item-number">
                      <po-info p-label="Item" [p-value]="item.number">
                      </po-info>
                    </div>
                    <div class="item-actions">
                      <po-tag
                        [p-value]="getItemStatusValue(item.conferred, item.expected)"
                        [p-type]="getItemStatusType(item.conferred, item.expected)">
                      </po-tag>
                    </div>
                  </div>
                  <div class="item-body">
                    <po-info *ngIf="item.batchBarCode" p-label="Lote" [p-value]="item.batchBarCode">
                    </po-info>
                    <po-info p-label="Descrição" [p-value]="item.description">
                    </po-info>
                    <po-info *ngIf="item.location" [p-label]="item.locationIsLast ? 'Última Localização' : 'Localização Atual'" [p-value]="item.location">
                    </po-info>
                    <po-info p-label="Esperada/Conferida" [p-value]="item.expected + '/' + item.conferred">
                    </po-info>
                  </div>
                </div>
              </div>
            </div>
          </po-container>
        </div>
      </div>
    </div>
  </div>
</po-page-default>